import { render, staticRenderFns } from "./CameraIris.vue?vue&type=template&id=2133d124"
import script from "./CameraIris.vue?vue&type=script&lang=js"
export * from "./CameraIris.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports